import GlobirdSelectorOption from 'data/GlobirdSelectorOption';

const menuOptions: GlobirdSelectorOption<string>[] = [
    { name: "Pay my bill", value: "payBill" },
    { name: "Previous bill", value: "billingHistory" },
    { name: "Payment history", value: "paymentHistory" },
    { name: "Bill extension", value: "billextension" }
];
export default menuOptions;
